<template>
    <div id="forgot-password-page" class="content">
        <h3>Reset your password</h3>
        <form @submit.prevent="submit">
            <template v-if="!submitted">
            <p>
                <label>Enter your e-mail address:
                    <input type="email" name="email" v-model="email">
                </label>
            </p>
            <p>
                <button>Submit</button>
            </p>
            </template>
            <template v-else>
            <p>
                A link has been sent to your email with instructions 
                on how to reset your password.
            </p>
            </template>
        </form>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'forgot-password-page',
    data() {
        return {
            email: '',
            submitted: false,
            errorMsg: '',
        }
    },
    methods: {
        async submit() {
            let r = await axios.post('/api/forgot-password', {email: this.email})

            if (r.status != 200) {
                this.errorMsg = r.data.message
                return
            }

            this.submitted = true
        }
    }
}
</script>

<style lang="scss">
@import "../scss/include-media";

#forgot-password-page {
    padding: 50px 100px;
    @include media("<=tablet") {
        padding: 50px;
    }
    &.content {
        @include media(">tablet") {
            max-width: 65vw;
        }
    }
}
</style>
